module.exports = __webpack_public_path__ + "img/new_unactive_01.b97d7a56.jpg";